export default "__VITE_ASSET__DBdTkm6B__"